import { getCmsNetworkMapStations } from "../../../app/api/getCmsNetworkMapStations";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse, ICmsNetworkMapStations, ICmsNetworkMapStationsResponse } from "../../../Orchestrator/Types/Index";

class GetCmsNetworkMapStationsWithoutBestPriceAction extends BaseAction<ICmsNetworkMapStations[], void> {
  override async run(): Promise<ICmsNetworkMapStations[] | null> {
    let listOfData: ICmsNetworkMapStations[] = [];
    try {
      updateRecoilState("networkMapStationResponseAtom", []);
      const response: IApiResponse<ICmsNetworkMapStationsResponse> = await getCmsNetworkMapStations();
      if (response.status === "ok" && response.answer) {
        listOfData = response.answer.data;
      } else {
        console.warn("Failed to fetch data.");
      }
    } catch (error: any) {
      console.error("Error fetching data:", error);
    } finally {
      updateRecoilState("networkMapStationResponseAtom", listOfData);
      return listOfData;
    }
  }
}

export const getCmsNetworkMapStationsWithoutBestPriceAction = new GetCmsNetworkMapStationsWithoutBestPriceAction()
